<template>
    <section class="bg--white m-0 position-relative no-padding">
        <div class="container-fluid">
            <div class="row">
                <div class="main col-12 col-md-6 offset-md-3">
                    <div
                        class="col-12 mt-5 mb-4 d-flex justify-content-md-center align-items-center"
                    >
                        <h2 class="color--purple-2 heading-spacing--large">
                            Activeer account
                        </h2>
                    </div>

                    <slot name="introductionText"></slot>

                    <form action="" class="row">
                        <div class="col-12 col-lg-10 mb-4">
                            <label for="password" class="col-12 label--default"
                                >Wachtwoord</label
                            >
                            <input
                                id="password"
                                v-model="password"
                                class="input--default input--rounded"
                                type="password"
                                placeholder="Wachtwoord"
                            />
                        </div>

                        <div class="col-12 col-lg-10 mb-4">
                            <label
                                for="passwordRepeat"
                                class="col-12 label--default"
                                >Wachtwoord herhalen</label
                            >
                            <input
                                id="passwordRepeat"
                                v-model="passwordRepeat"
                                class="input--default input--rounded"
                                type="password"
                                placeholder="Wachtwoord herhalen"
                            />
                        </div>

                        <div
                            v-if="!processing"
                            class="col-12 col-lg-10 d-flex justify-content-md-center align-items-center"
                        >
                            <button
                                class="col-8 btn btn--blue-7"
                                @click="activate"
                            >
                                <span>
                                    Activeer account
                                    <i class="fas fa-arrow-right ml-2"></i>
                                </span>
                            </button>
                        </div>
                        <div
                            v-else
                            class="col-12 col-lg-10 d-flex justify-content-md-center align-items-center"
                        >
                            <span>Een moment geduld...</span>
                        </div>

                        <div
                            class="col-12 col-lg-10 d-flex justify-content-md-center align-items-center"
                        >
                            <p>{{ statusMessage }}</p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';

export default {
    props: {},
    data() {
        return {
            password: '',
            passwordRepeat: '',
            response: '',
            statusMessage: '',
            processing: false
        };
    },
    mounted() {},
    methods: {
        activate(e) {
            e.preventDefault();
            this.statusMessage = '';
            this.processing = true;
            axios
                .post('/clientdashboard/account/activate', {
                    password1: this.password,
                    password2: this.passwordRepeat,
                    token: this.$route.query.token,
                    guid: this.$route.query.guid
                })
                .then(response => {
                    this.response = response;
                    if (response.data.success) {
                        window.location.replace(response.data.redirectUrl);
                    } else {
                        this.statusMessage = response.data.errorMsg;
                    }
                    return;
                })
                .catch(e => {
                    this.errors.push(e);
                })
                .finally(() => {
                    this.processing = false;
                });
        }
    }
};
</script>
<style></style>
